/**************************************************
 * Nombre:       Tarjeta_Capacitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {GRADIENTE, URLUSUARIO} from "../../Constantes";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Capacitaciones = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 6, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width="100%" height={'auto'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 7}} sx={{justifyContent: 'flex-start', pl: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{color: '#262626', fontSize: !masSM ? 18 : 24, fontWeight: 700, lineHeight: 1.1}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{
                            color: '#545454', fontSize: !masSM ? 14 : 16, fontWeight: 400, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: !masSM ? 6 : 8
                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Button
                            onClick={() => irUrl(URLUSUARIO + 'ingreso')}
                            sx={{background: GRADIENTE}}
                        >Ingresar</Button>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Capacitaciones